import { combineReducers } from "redux";
import * as types from "../actions/actionTypes";
import availableDates from "./availableDatesReducer";
import availableHours from "./availableHoursReducer";
import enrollee from "./enrolleeReducer";
import locations from "./locationsReducer";
import vehicle from "./vehicleReducer";
import referral from "./referralReducer";
import statesList from "./statesListReducer";

const appReducer = combineReducers({
  availableDates,
  availableHours,
  enrollee,
  locations,
  vehicle,
  referral,
  statesList,
});

const rootReducer = (state, action) => {
  if (
    action.type === types.ENROLLEE_LOGIN_SUCCESS ||
    action.type === types.ENROLLEE_LOGOUT_SUCCESS
  ) {
    state = {};
  }
  return appReducer(state, action);
};

export default rootReducer;
